import { Center, Link, Text } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { useStore } from "@src/utils/hooks";
import { differenceInDays } from "date-fns";
import { observer } from "mobx-react-lite";
import { type FC, Fragment } from "react";

const TRIAL_LENGTH = 14;

const SupportTeam: FC<{ subject: string }> = ({ subject }) => (
  <Link
    color="blue.500"
    textDecoration="underline"
    href={`mailto:support@allfred.io?subject=${subject}`}
  >
    <Trans>support team</Trans>
  </Link>
);

export const TrialNav: FC = observer(function TrialNav() {
  const { workspaceStore } = useStore();
  if (workspaceStore.settings?.unpaidBannerMessage) return null;
  if (!workspaceStore.settings?.trial_from) return null;

  const trialFrom = new Date(workspaceStore.settings.trial_from);
  const daysSinceTrialStart =
    TRIAL_LENGTH - differenceInDays(new Date(), trialFrom);
  const trialEnded = daysSinceTrialStart < 0;

  return (
    <Center
      w="full"
      py="1"
      pl={{ md: 20 }}
      bg={trialEnded ? "red.400" : "orange.200"}
    >
      <Text textAlign="center">
        {trialEnded ? (
          <Fragment>
            <Trans>
              Your trial period has ended. Need more time? Contact our friendly
            </Trans>
            &nbsp;
            <SupportTeam subject={t`Need more trial time`} />.
          </Fragment>
        ) : (
          <Fragment>
            <Trans>You’ve still got</Trans>
            &nbsp;
            {daysSinceTrialStart}
            &nbsp;
            <Trans>
              days left in your trial, make them count! Need help? Just contact
              our friendly
            </Trans>
            &nbsp;
            <SupportTeam subject={t`Need help`} />.
          </Fragment>
        )}
      </Text>
    </Center>
  );
});
